import { type MutationHookOptions, useMutation } from "@apollo/client";
import { TerminateProductPurchaseMutation } from "../graphql/mutations";
import type {
  TerminateProductPurchaseMutationType,
  TerminateProductPurchaseMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useTerminateProductPurchaseMutation = (
  options?: MutationHookOptions<
    TerminateProductPurchaseMutationType,
    TerminateProductPurchaseMutationVariablesType
  >
) => {
  return useMutation<
    TerminateProductPurchaseMutationType,
    TerminateProductPurchaseMutationVariablesType
  >(TerminateProductPurchaseMutation, options);
};
